<div class="live-sources-toolbar">
  <div class="live-sources-toolbar__filters-row">
    <div class="live-sources-toolbar__search-wrapper">
      <ichannel-input
        [placeholder]="'Search sources...'"
        [value]="searchQuery"
        (valueChange)="onSearchValueChange($event)"
      ></ichannel-input>
      @if (searchQuery) {
        <button type="button" class="live-sources-toolbar__clear" (click)="onClearSearch()" aria-label="Clear search">
          &times;
        </button>
      }
    </div>
    <icn-dropdown
      class="live-sources-toolbar__status-dropdown"
      [selectedValue]="statusFilter"
      (selectedValueChange)="onStatusValueChange($event)"
      [position]="'bottom'"
      [medium]="true"
      [allowMultiple]="false"
    >
      <icn-dropdown-item [title]="'All Statuses'" [value]="'All'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Active'" [value]="'Active'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Paused'" [value]="'Paused'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Error'" [value]="'Error'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Idle'" [value]="'Idle'"></icn-dropdown-item>
    </icn-dropdown>
    <icn-dropdown
      class="live-sources-toolbar__protocol-dropdown"
      [selectedValue]="protocolFilter"
      (selectedValueChange)="onProtocolValueChange($event)"
      [position]="'bottom'"
      [medium]="true"
      [allowMultiple]="false"
      aria-label="Protocol filter"
    >
      <icn-dropdown-item [title]="'All Protocols'" [value]="'All'"></icn-dropdown-item>
      @for (opt of protocolOptions; track opt.value) {
        <icn-dropdown-item [title]="opt.label" [value]="opt.value"></icn-dropdown-item>
      }
    </icn-dropdown>
  </div>
</div>
